
import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { TopicHeader } from '../TopicHeader';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import Api, { createFetchErrorMessage } from 'utils/api/Api';

export const StoryForm = ({ story = null, useTemp = false }) => {
    const navigate = useNavigate();

    const { school, topicId, storyId } = useParams();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const queryClient = useQueryClient();

    // 수정일때는 불러온다
    useEffect(() => {
        if (!story) return;
        setTitle(story.title);
        setContent(story.content);
    }, [story]);

    // ------------------ 임시저장
    const tempStory = useQuery({
        queryKey: ['donghwa/story/temp', topicId],
        queryFn: () => {
            if (!useTemp) return null;
            return Api.get(`/api/dongwha/topic/${topicId}/temp`);
        },
        refetchOnMount: 'always'
    });

    const storeTempStoryMutate = useMutation({
        mutationFn: (data) => Api.post('/api/dongwha/topic/temp/store', data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['donghwa/story/temp', topicId] });
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    });

    // 스토리 임시 저장 함수
    const onSaveTempStory = () => {
        if (storeTempStoryMutate.isPending) return;
        // 임시 저장인데 뭔 조건이 이렇게 까다로웡?
        if (title <= 0) return toast.error("제목을 입력해주세요.");
        if (title.length > 100) return toast.error("제목이 너무 길어요.");
        if (content.length <= 0) return toast.error("내용을 입력해주세요.");
        if (!window.confirm("임시저장을 하겠습니까?")) return;

        storeTempStoryMutate.mutate({ title, content, topicId });
    };


    // 임시 저장한 스토리를 가져오는 함수
    const onLoadTempStory = useCallback(() => {
        if (!useTemp) return;
        if (tempStory.isLoading) return;
        if (!window.confirm("임시저장을 불러 오겠습니까?")) return;
        setTitle(tempStory.data.data?.title || '');
        setContent(tempStory.data.data?.content || '');
    }, [useTemp, tempStory]);


    // /--------------- 저장

    const sotreStoryMutate = useMutation({
        mutationFn: (data) => Api.post('/api/dongwha/story/store', data),
        onSuccess: (res) => {
            toast.success("저장되었습니다.");
            queryClient.invalidateQueries({ queryKey: ['donghwa/topic/stories', { page: 0, sort: 'id,desc', bestYn: 'N', user: 'N', topicId }] });
            const oldData = queryClient.getQueriesData(['donghwa/story', storyId]);
            queryClient.setQueryData(['donghwa/story', storyId], { ...oldData, data: res.data });

            navigate(`/${school}/donghwa/story/${res.data?.id}`);
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err);
            toast.error(errorData.message);
        }
    })


    // 스토리 저장 함수
    const onStore = () => {
        if (sotreStoryMutate.isPending) return;
        if (title.length <= 0) return toast.error("제목을 입력해주세요.");
        if (title.length > 100) return toast.error("제목이 너무 길어요.");
        if ([...content.replace(/ /gi, '')].length < 400) return toast.error("400자 이상 입력해주세요.");

        // 서버에 스토리 저장 요청시 필요한 데이터 변수에 담아 정리
        const storeData = { id: storyId, title, content, topicId };
        sotreStoryMutate.mutate(storeData);
    };


    const onChangeContent = (event) => {
        const oldContentLength = content.length;
        if (event.target.value.length - oldContentLength > 10) {
            window.location = `/${school}/errorPaste?type=dongwha`;
        }
        setContent(event.target.value);
    };





    return (
        <>
            <TopicHeader />
            <div className="storyForm contents">
                <div className="hdline side">
                    <p className="desc">자기만의 <span>이야기</span>를 만들어보세요.</p>
                    {useTemp && tempStory?.data && <button className="btn _sm _blue" onClick={onLoadTempStory}><i className="fa-solid fa-pencil"></i> 임시저장 불러오기</button>}
                </div>
                <input type="text" name="title" value={title} placeholder="제목을 입력해주세요." onChange={e => setTitle(e.target.value)} />
                <textarea name="content" onPaste={e => e.preventDefault()} value={content} placeholder="동화를 작성해주세요." onChange={onChangeContent}></textarea>
                <p className="content_num"><span>{[...content.replace(/(?:\r\n|\r|\n| )/gi, '')].length}</span> 자</p>

                <div className="item_btn center">
                    {useTemp && <button typle="button" className="btn _red" onClick={onSaveTempStory}>임시저장</button>}
                    <button typle="submit" className="btn _blue" onClick={onStore}>등록</button>
                    <Link to={`/${window.schoolCode}/donghwa/${topicId}`} className="btn _white">취소</Link>
                </div>
            </div>
        </>

    );

};